export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        
      },
      "fr": {
        "ask_no_found_company": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous ne trouvez pas l'entreprise recherchée ?"])},
        "solution_for_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nos enquêteurs la trouvent pour vous !"])},
        "request_inquiry": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Demander une enquête"])},
        "inquiry_quota_reached_message": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Vous avez déjà ", _interpolate(_named("count")), " demandes en cours. Afin de fluidifier la qualité de leurs traitements, veuillez patienter pour faire votre prochaine demande."])}
      }
    }
  })
}
